// src/modules/app-views/account/pages/Subscription/tabs/RecordTab/RegisterCard.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Card, Tooltip } from 'antd';
import translateX from 'utils/translateX';
import SimpleEntityForm from 'components/SimpleComponents/SimpleEntityForm/SimpleEntityForm';
import { QuestionCircleOutlined } from '@ant-design/icons';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const EntityRegisterCard = ({ setState, state = {} }) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // Default state values if not provided (prevents undefined errors during initial render)
  const safeState = {
    dataOrigin: state.dataOrigin || 'new_data',
    entityType: state.entityType || 'company',
    entityProfile: state.entityProfile || ['subscription', 'company'],
    ...state,
  };

  // ─────────────────────────────────────────────────────────────────────────────
  // 2. HOOKS & REFS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 4. LOCAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 5. EFFECTS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 6. HANDLERS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 7. LOCAL VARIABLES II
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  const cardTitle = (
    <div className="text-muted">
      {translateX('your_main_company')}
      <Tooltip title={translateX('main_company_info_description')}>
        <QuestionCircleOutlined style={{ marginLeft: 8, cursor: 'normal' }} />
      </Tooltip>
    </div>
  );

  return (
    <Card title={cardTitle} className="no-shadow">
      <SimpleEntityForm
        setState={setState}
        state={safeState}
        selectable={false}
        dataOrigin={safeState.dataOrigin}
        showAdditionalInfoForm={true}
        showAddressForm={true}
        // entity setting
        entityTypeModel={safeState.entityType}
        entityType={safeState.entityType}
        unique={true} // unique company by cnpj
        searchCnpjByApi={true} // search cnpj by api
        // country selectors
        hideFormCountrySelector={true}
        hideAddressCountrySelector={true}
        // phone setting
        companyPhoneProfile={null}
        showNote={false}
      />
    </Card>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default EntityRegisterCard;

// *******************************************************************************
// HELPERS
// *******************************************************************************
